"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartSidePanel = void 0;
const React = require("react");
const react_transition_group_1 = require("react-transition-group");
const cssTransitions_1 = require("../../../../../helpers/cssTransitions");
const CheckoutButton_1 = require("./CheckoutButton");
const SidePanelBackground_1 = require("./SidePanelBackground");
const CloseButton_1 = require("./CloseButton");
const SidePanelContent_1 = require("./SidePanelContent");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "CartSidePanel");
const CartSidePanel = ({ open, setOpen }) => (React.createElement("div", { "data-test": "side-panel", className: css("", {
        "-fixed": true
    }) },
    React.createElement(SidePanelBackground_1.SidePanelBackground, { open: open, setOpen: setOpen }),
    React.createElement(react_transition_group_1.CSSTransition, { in: open, unmountOnExit: true, classNames: cssTransitions_1.sidePanelSwitchTransition, timeout: 500 },
        React.createElement("div", { className: css("panel") },
            React.createElement(SidePanelContent_1.SidePanelContent, null),
            React.createElement(CloseButton_1.CloseButton, { setOpen: setOpen }),
            React.createElement(CheckoutButton_1.CheckoutButton, null)))));
exports.CartSidePanel = CartSidePanel;
//# sourceMappingURL=index.js.map